import { getSourceCode } from '../../../../../common/sourceCodeHelper';
export function discountCodeEventManager(form) {
    const discountCodeInput = document.getElementById('discount');
    const sourceCode = getSourceCode();
    if (sourceCode && sourceCode !== 'defaultSourceCode') {
        discountCodeInput.value = sourceCode;
        form.set('sourceCode', sourceCode);
    }
    discountCodeInput.addEventListener('input', () => {
        form.set('sourceCode', discountCodeInput.value);
    });
}
